import OrderService from "@/services/OrderService.js";

export const namespaced = true;

export const state = {
  one_time_orders: [],
  order_edit: {},
  expedite_request: {}
};

export const mutations = {
  SET_ONE_TIME_ORDERS(state, orders) {
    state.one_time_orders = orders;
  },
  SET_ORDER_EDIT(state, order_edit) {
    state.order_edit = order_edit;
  },
  ADD_EXPEDITED_REQUEST(state, request) {
    state.expedite_request = request;
  }
};

export const getters = {
  getOrderById: state => id => {
    //console.log(state)
    return state.one_time_orders.find(order => order.OrderID === id);
  },
  OrderCount: state => {
    return state.one_time_orders.length;
  }
};

export const actions = {
  getOTOrders({ commit }) {
    //alert("commit")
    return OrderService.get_OTOrders()
      .then(response => {
        commit("SET_ONE_TIME_ORDERS", response.data);
      })
      .catch(error => {
        console.log(error.message);
      });
  },
  loadOrderEdit({ commit, getters, dispatch }, value) {
    //This is good, use getters first then call api
    // changing it to test progress bars
    {
      return OrderService.Load_OTOrder(value)
        .then(response => {
          commit("SET_ORDER_EDIT", response.data["OneTimeOrderResult"]);
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  createRequest({ commit }) {
    var request = { ExpShipReqID: -1 };
    return commit("ADD_EXPEDITED_REQUEST", request);
  },
  llCloseOTOrder({ commit, dispatch }, op) {
    //console.log(op);
    return OrderService.LLCloseOTOrder(op).then(dispatch("getOTOrders"));
  }
};
